import * as core from '../../../../../../../core'
import * as prebuilt from '../../../../../../prebuilt'
import * as dolomiteGeneral from '../dolomite-general'

export const RESOURCE = {
  payload: {
    alias: 'chat',
    appAlias: dolomiteGeneral.RESOURCE.payload.alias,
    description:
      'Ask general questions about Ascend and Princeton architecture',
    display: {
      isMain: true,
      position: 2,
    },
    name: 'Chat',
    page: { id: prebuilt.Page.Id.DolomiteGeneralChat },
  },
  type: core.quiver.Resource.Type.AppPage,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.AppPage>
